import React, { useEffect, useRef } from "react";
import "../../App.css";

const AestheticCursor = () => {
  const dotRef = useRef(null);
  const ringRef = useRef(null);

  const mouse = useRef({ x: 0, y: 0 });
  const ringPos = useRef({ x: 0, y: 0 });
  const hasMoved = useRef(false);

  useEffect(() => {
    const onMouseMove = (e) => {
      mouse.current.x = e.clientX;
      mouse.current.y = e.clientY;

      // On first cursor movement, snap coordinates and fade in
      if (!hasMoved.current) {
        hasMoved.current = true;
        ringPos.current.x = e.clientX;
        ringPos.current.y = e.clientY;

        if (dotRef.current) dotRef.current.classList.remove("cursor-hidden");
        if (ringRef.current) ringRef.current.classList.remove("cursor-hidden");
      }

      if (dotRef.current) {
        dotRef.current.style.transform = `translate(${mouse.current.x}px, ${mouse.current.y}px) translate(-50%, -50%)`;
      }
    };

    const onMouseLeave = () => {
      if (dotRef.current) dotRef.current.classList.add("cursor-hidden");
      if (ringRef.current) ringRef.current.classList.add("cursor-hidden");
    };

    const onMouseEnter = () => {
      if (hasMoved.current) {
        if (dotRef.current) dotRef.current.classList.remove("cursor-hidden");
        if (ringRef.current) ringRef.current.classList.remove("cursor-hidden");
      }
    };

    window.addEventListener("mousemove", onMouseMove);
    document.addEventListener("mouseleave", onMouseLeave);
    document.addEventListener("mouseenter", onMouseEnter);

    const render = () => {
      const ease = 0.15;

      ringPos.current.x += (mouse.current.x - ringPos.current.x) * ease;
      ringPos.current.y += (mouse.current.y - ringPos.current.y) * ease;

      if (ringRef.current) {
        ringRef.current.style.transform = `translate(${ringPos.current.x}px, ${ringPos.current.y}px) translate(-50%, -50%)`;
      }

      requestAnimationFrame(render);
    };

    const animFrame = requestAnimationFrame(render);

    return () => {
      window.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseleave", onMouseLeave);
      document.removeEventListener("mouseenter", onMouseEnter);
      cancelAnimationFrame(animFrame);
    };
  }, []);

  return (
    <>
      {/* Starts hidden by default */}
      <div className="custom-cursor-dot cursor-hidden" ref={dotRef} />
      <div className="custom-cursor-ring cursor-hidden" ref={ringRef} />
    </>
  );
};

export default AestheticCursor;